import React, {useEffect, useState} from "react"

import r1 from "../../images/luca-pay/r1.svg"
import r1Mob from "../../images/luca-pay/r1_mob.svg"
import r2 from "../../images/luca-pay/r2.svg"
import r2Mob from "../../images/luca-pay/r2_mob.svg"
import r3 from "../../images/luca-pay/r3.svg"
import r3Mob from "../../images/luca-pay/r3_mob.svg"
import r4 from "../../images/luca-pay/r4.svg"
import r4Mob from "../../images/luca-pay/r4_mob.svg"
import r5 from "../../images/luca-pay/r5.svg"
import r5Mob from "../../images/luca-pay/r5_mob.svg"
import creditCard from "../../images/luca-pay/credit-card.svg"
import requirementSupplier from "../../images/luca-pay/requirement-sup.svg"
import RightVectorGreenImage from "../../images/new-landing/right-vector-green.svg";
import questionImg from "../../images/luca-pay/question-icon.svg";
import Tooltip from "rc-tooltip";
import ReactGA from "react-ga";

const CustomToolTip = props => {
    const tooltipStyle = {
        height: "auto",
        width: props.width,
        textAlign: "center",
        verticalAlign: "middle",
    }
    return (
        <Tooltip
            overlayStyle={tooltipStyle}
            placement="top"
            overlay={props.tooltipText}
            trigger={["hover"]}
            arrowContent={<div className="rc-tooltip-arrow-inner" />}
        >
            {props.children}
        </Tooltip>
    )
}

export default function Requirements({supplier, toggleConfirmationPopup}) {
    const requirements = !supplier ? supplierRequirements : purchaserRequirements;

    const startNowClick = (title, index) => {
        ReactGA.event({
            category: `LUCA Pay_${title} start now1_Green button`,
            action: `LUCA Pay_${title} start now1_Green button Clicked`
        });
        toggleConfirmationPopup(`startnow_arrow_${index}`);
    }
    return (
        <div className="lucapay__requirements">
            <h2 className="header font-bold">
                {!supplier ? "First time using LUCA Pay?" : "What you need to know when signing up to LUCA Pay"}
                <div className="sub-header text-neutral-3 text-16 font-normal mt-8 mx-auto">
                    {!supplier && "To make sure your sign up process is as smooth as possible, check out the conditions and actions below"}
                </div>
            </h2>
            <div className="flex justify-between flex-wrap box-wrap">
                {requirements.map(({image, title, content, tooltipText, className = "", titleClassName}, index) => (
                    <div className="box" key={index}>
                        <img src={image} className="mx-auto"/>
                        <div className={`flex justify-content-center items-start capitalize font-bold text-18 leading-5 my-6 ${titleClassName}`}>
                            {title}
                            {tooltipText && <CustomToolTip
                                height="46px"
                                width="160px"
                                tooltipText={
                                    <span>{tooltipText}</span>}
                            >
                                <img
                                    src={questionImg}
                                    className="ml-1"
                                    alt="luca"
                                    data-parallax='{"x" : -50}'
                                />
                            </CustomToolTip>}
                        </div>
                        <div className={`text-neutral-3 text-16 leading-6 content ${className}`}>
                            {content}
                        </div>
                        <a
                            onClick={() =>  startNowClick(title, index + 1)}
                            className="start-now-btn flex justify-content-center mt-4 text-base uppercase focus:outline-none cursor-pointer"
                        >
                            Start Now
                            <img src={RightVectorGreenImage} className="ml-2" alt="right arrow"/>
                        </a>
                    </div>
                ))}
                <div className="box bg-none">
                    <img src={requirementSupplier} />
                </div>
            </div>
        </div>
    )
}

const supplierRequirements = [
    {
        image: r1,
        title: "Valid ABN",
        className: "px-2",
        content: "We need to ensure that your business is registered in Australia and is also active",
        tooltipText: "Your bank account name needs to match your ABN"
    },
    {
        image: r2,
        title: "GST registered",
        content: "To ensure you’re receiving ample cash flow to cover larger invoice amounts, you must be registered"
    },
    {
        image: r3,
        title: "Your Financials",
        content: "Simply sync your existing Accounting software to avoid having to send us any paper work"
    },
    {
        image: r4,
        titleClassName: "mb-2",
        className: "basiq-text",
        title: <div>Basiq Open Banking <div className="box-sub-header"> powered by NAB </div></div>,
        content: "Link your business bank account upon sign up to ensure you have sufficient funds to cover direct debits",
        tooltipText: "Your bank account name needs to match your ABN",
    },
    {
        image: r5,
        title: "Set up Direct Debit",
        content: "Once you link your business bank account, you can set up your Direct Debit"
    },
]

const purchaserRequirements = [
    {
        image: r1,
        title: "Valid ABN",
        content: "We need to ensure that your business is registered in Australia and is also active",
        tooltipText: "Your bank account name needs to match your ABN"
    },
    {
        image: r2,
        title: "GST registered",
        content: "To ensure you’re receiving ample cash flow to cover larger invoice amounts, you must be registered"
    },
    {
        image: r3,
        title: "Your Financials",
        content: "Simply sync your existing Accounting software to avoid having to send us any paper work"
    },
    {
        image: r4,
        title: "Link Bank Account",
        content: "Link your business bank account upon sign up to ensure you have sufficient funds to cover direct debits",
        tooltipText: "Basiq Open Banking - powered by NAB"
    },
    {
        image: r5,
        className: "px-2",
        title: "Set up Direct Debit",
        content: "Once you link your business bank account, you can set up your Direct Debit "
    },

]